import { atom } from "recoil";

const loadingState = atom<boolean>({ key: "LoadingState", default: false });
export { loadingState };
